module.exports = __webpack_public_path__ + "img/channel-type-icon-on.7998aa87.svg";